/**
 * Prodotti di nicchia certificati 6Amico — sola lista curata admin (no auto da prodotti_tipici).
 * Ogni voce richiede `ratingEsemplare` (sigillo Amministratore Unico).
 */

import { SAGRA_PORCHETTA_ITALICA_URL } from "./economiaLocaleLinks";

/** @type {import('../types/borgoData').ProdottoCertificato[]} */
export const PRODOTTI_CERTIFICATI_SEED = [
  {
    id: "cert-porchetta-campli",
    borgoSlug: "campli",
    nome: "Porchetta di Campli — Maiale Nero d'Abruzzo",
    produttore: "La Porchetta di Campli",
    categoria: "Enogastronomia d'Élite",
    prezzoRiferimento: "€ 28 / kg",
    fotoProdotto: "/images/prodotti/porchetta-campli.jpg?v=3",
    qrParlanteUrl: "/qr/porchetta-campli-cert",
    eCommerceDiretto: SAGRA_PORCHETTA_ITALICA_URL,
    ratingEsemplare: {
      numeroProtocollo: "6A-ENOG-2024-0142",
      dataApprovazione: "2024-11-08",
      selezionatoDa: "Amministratore Unico 6Amico",
      valutazioneVoto: 9.8,
      giudizioSartoriale:
        "Cottura lenta su legna di castagno; crosta croccante e interno rosato — esemplare della tradizione campliatese.",
      garanziaAutenticita:
        "Tracciabilità DOP Maiale Nero d'Abruzzo · filiera verificata entro 15 km dal borgo.",
      enteScientificoSupporto: "Consorzio Maiale Nero d'Abruzzo · panel sensoriale 6Amico",
    },
  },
  {
    id: "cert-ceramica-castelli",
    borgoSlug: "castelli",
    nome: "Piatto ceramica istoriato — Bottega Castelli",
    produttore: "Laboratorio Ceramica d'Arte",
    categoria: "Artigianato Artistico Storico",
    prezzoRiferimento: "€ 120",
    fotoProdotto: "/images/prodotti/ceramica-piatto.jpg",
    qrParlanteUrl: "/qr/ceramica-castelli-cert",
    eCommerceDiretto: "/prodotti?comune=castelli&cert=ceramica",
    ratingEsemplare: {
      numeroProtocollo: "6A-ART-2025-0031",
      dataApprovazione: "2025-02-14",
      selezionatoDa: "Amministratore Unico 6Amico",
      valutazioneVoto: 9.6,
      giudizioSartoriale:
        "Smalto cristallino e pennellatura a mano libera — continuità documentata della scuola castellana.",
      garanziaAutenticita:
        "Marcatura bottega e certificato di autenticità numerato · nessuna produzione seriale industriale.",
      enteScientificoSupporto: "Museo delle Ceramiche Castelli · commissione 6Amico",
    },
  },
  {
    id: "cert-olio-mosciano",
    borgoSlug: "mosciano-sant-angelo",
    nome: "EVO Monocultivar Aprutino — Frantoio Aprutino",
    produttore: "Oleificio Aprutino",
    categoria: "Enogastronomia d'Élite",
    prezzoRiferimento: "€ 14,50 / 500ml",
    fotoProdotto: "/images/prodotti/olio-evo.jpg",
    qrParlanteUrl: "/qr/olio-aprutino-cert",
    eCommerceDiretto: "/prodotti?comune=mosciano-sant-angelo&cert=olio",
    ratingEsemplare: {
      numeroProtocollo: "6A-ENOG-2025-0088",
      dataApprovazione: "2025-01-20",
      selezionatoDa: "Amministratore Unico 6Amico",
      valutazioneVoto: 9.4,
      giudizioSartoriale:
        "Fruttato medio con note di carciofo e mandorla amara — estrazione a freddo entro 12 ore dalla raccolta.",
      garanziaAutenticita:
        "Analisi chimico-sensoriale lotto · origine oliveti collinari del Fino certificata.",
      enteScientificoSupporto: "Panel oleologico 6Amico · CNR-ISA referenza campionaria",
    },
  },
  {
    id: "cert-ceramica-campli",
    borgoSlug: "campli",
    nome: "Brocca istoriata — Bottega della Ceramica",
    produttore: "Bottega della Ceramica Castelli (filiale Campli)",
    categoria: "Artigianato Artistico Storico",
    prezzoRiferimento: "€ 85",
    fotoProdotto: "/images/prodotti/ceramica-brocca.jpg",
    qrParlanteUrl: "/qr/ceramica-campli-cert",
    eCommerceDiretto: "/prodotti?comune=campli&cert=brocca",
    ratingEsemplare: {
      numeroProtocollo: "6A-ART-2024-0199",
      dataApprovazione: "2024-09-30",
      selezionatoDa: "Amministratore Unico 6Amico",
      valutazioneVoto: 9.2,
      giudizioSartoriale: "Decorazione narrativa su forme tradizionali — pezzo unico da atelier certificato.",
      garanziaAutenticita: "Certificato di provenienza bottega · foto lotto in archivio 6Amico.",
      enteScientificoSupporto: "Rete botteghe storiche Terre di Campli",
    },
  },
  {
    id: "cert-miele-castiglione",
    borgoSlug: "castiglione-messer-raimondo",
    nome: "Miele di acacia della Vallata",
    produttore: "Frantoio della Vallata",
    categoria: "Enogastronomia d'Élite",
    prezzoRiferimento: "€ 12 / 250g",
    fotoProdotto: "/images/prodotti/confettura.jpg",
    qrParlanteUrl: "/qr/miele-vallata-cert",
    eCommerceDiretto: "/prodotti?comune=castiglione-messer-raimondo&cert=miele",
    ratingEsemplare: {
      numeroProtocollo: "6A-ENOG-2025-0044",
      dataApprovazione: "2025-03-02",
      selezionatoDa: "Amministratore Unico 6Amico",
      valutazioneVoto: 9.1,
      giudizioSartoriale: "Cristallizzazione lenta, profilo floreale pulito — apicoltura nomade in Vallata.",
      garanziaAutenticita: "Analisi melissopalinologica · filiera km zero Valle del Fino.",
      enteScientificoSupporto: "Consorzio Apicoltori Abruzzo · verifica GPS alveari",
    },
  },
];

function publicProdotti() {
  // eslint-disable-next-line global-require
  const { getPublicProdottiCertificati } = require("./certificatoAdminData");
  return getPublicProdottiCertificati();
}

export function getCertificazioneNetworkKpi() {
  return [
    { id: "prodotti-sigillo", label: "Prodotti sigillo 6Amico", value: publicProdotti().length },
  ];
}

/** @deprecated use getCertificazioneNetworkKpi — valore dinamico */
export const CERTIFICAZIONE_NETWORK_KPI = [
  { id: "prodotti-sigillo", label: "Prodotti sigillo 6Amico", value: PRODOTTI_CERTIFICATI_SEED.length },
];

/** @param {string} slug */
export function getProdottiCertificatiBySlug(slug) {
  return publicProdotti().filter((p) => p.borgoSlug === slug);
}

export function getAllProdottiCertificati() {
  return publicProdotti();
}
